import router from "@/router";
import {DialogStore} from "@/modules/Popup/stores/dialog.store";
import store from "@/store/store";
import {isMobile} from "mobile-device-detect";

export class RouteTracker {
  historyRoutes = [];

  init() {
    router.afterEach((to, from) => {
      this.historyRoutes.push({to, from});

      if (isMobile && !to.params.withoutChecking) {
        let hasOpenDialogs = this.hasOpenDialogs();
        if (hasOpenDialogs && from.query.dialog && !to.query.notClose) {
          store.commit('dialog/closeAllDialogs');
        }
      }
    });

  }

  hasOpenDialogs() {
    let hasOpen = false;
    //@ts-ignore
    const dialogState = DialogStore.state;
    Object.keys(dialogState).forEach(blockName => {
      if (blockName !== 'payload') {
        Object.keys(dialogState[blockName]).forEach(dialogName => {
          if (dialogState[blockName][dialogName]) {
            hasOpen = true;
          }
        });
      }
    });

    return hasOpen;
  }
}

export const routeTracker = new RouteTracker();
